import { createAppStore } from 'store'

import services from 'services'
import axiosSetup from './axios.setup'
import i18nSetup from './i18n.setup'
import storeSetup from './store.setup'
import interceptorsSetup from './interceptors.setup'
import fontawesomeSetup from './fontawesome.setup'

export default {
  // Enforce it returns promise cuz it can be helpfull in future
  async setup() {
    const appStore = createAppStore({
      storage: localStorage,
      services,
    })

    // TODO: Think how to improve initialistion step
    await Promise.all([
      i18nSetup.setup(),
      Promise.resolve(axiosSetup.setup()),
      Promise.resolve(fontawesomeSetup.setup()),
      Promise.resolve(interceptorsSetup.setup(appStore, services)),
    ])

    await storeSetup.setup(appStore)

    return [appStore, services]
  },
}
